import { COLORS } from '../configs'
import { IFlagConfig, IIncomingFlag } from '../models'

export const buildFlagConfigs = (flags: IIncomingFlag[]): IFlagConfig[] =>
  [...flags]
    .sort((a, b) => a.bitValue - b.bitValue)
    .map((flag, i) => ({
      key: flag.bitValue,
      label: flag.label,
      bitValue: flag.bitValue,
      color: COLORS[i % COLORS.length],
    }))
